import { render, staticRenderFns } from "./FileSelector.vue?vue&type=template&id=67bb7e25&scoped=true"
import script from "./FileSelector.vue?vue&type=script&lang=js"
export * from "./FileSelector.vue?vue&type=script&lang=js"
import style0 from "./FileSelector.vue?vue&type=style&index=0&id=67bb7e25&prod&lang=scss&scoped=true"
import style1 from "./FileSelector.vue?vue&type=style&index=1&id=67bb7e25&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bb7e25",
  null
  
)

export default component.exports